"use strict";
const customerQuery = customer => {
    let result = 'is null';
    if (customer && customer.id) {
        result = `= '${customer.id}'`;
    }
    return result;
};
module.exports = { customerQuery };
